import { render, staticRenderFns } from "./BillStatus.vue?vue&type=template&id=571e7200&scoped=true&"
import script from "./BillStatus.vue?vue&type=script&lang=js&"
export * from "./BillStatus.vue?vue&type=script&lang=js&"
import style0 from "./BillStatus.vue?vue&type=style&index=0&id=571e7200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e7200",
  null
  
)

export default component.exports